// components/Toast.jsx - Reusable toast notification system
import { useState, useEffect } from 'react';

let toastId = 0;
let addToastCallback = null;

export const showToast = (message, type = 'success', duration = 3000) => {
  if (addToastCallback) {
    addToastCallback({ message, type, duration });
  }
};

const ToastContainer = () => {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    addToastCallback = ({ message, type, duration }) => {
      const id = toastId++;
      const newToast = { id, message, type, duration };
      
      setToasts((prevToasts) => [...prevToasts, newToast]);

      // Auto remove after duration
      setTimeout(() => {
        setToasts((prevToasts) => prevToasts.filter((t) => t.id !== id));
      }, duration);
    };

    return () => {
      addToastCallback = null;
    };
  }, []);

  const removeToast = (id) => {
    setToasts((prevToasts) => prevToasts.filter((t) => t.id !== id));
  };

  const getIcon = (type) => {
    switch (type) {
      case 'success':
        return 'fa-check-circle';
      case 'error':
        return 'fa-exclamation-circle';
      case 'warning':
        return 'fa-exclamation-triangle';
      default:
        return 'fa-info-circle';
    }
  };

  if (toasts.length === 0) return null;

  return (
    <div className="toast-container">
      {toasts.map((toast) => (
        <div key={toast.id} className={`toast ${toast.type}`}>
          <i className={`fas ${getIcon(toast.type)} toast-icon`}></i>
          <div className="toast-content">
            <p className="toast-message">{toast.message}</p>
          </div>
          <button 
            className="toast-close" 
            onClick={() => removeToast(toast.id)}
          >
            <i className="fas fa-times"></i>
          </button>
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;